import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';

export class AddressDisplay extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        addressLine1: PropTypes.string.isRequired,
        addressLine2: PropTypes.string,
        city: PropTypes.string.isRequired,
        state: PropTypes.string,
        postalCode: PropTypes.string.isRequired
    };

    render() {
        const { addressLine1, addressLine2, city, state, postalCode } = this.props;
        return (
            <div id="billingAddress">
                {addressLine1 != '' &&
                    <div className="confidential streets secondary prefilledAddress">
                        {addressLine1}, <br />
                        {addressLine2} {addressLine2 && <br />}
                        {city}, {state} {postalCode}
                    </div>
                }
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    addressLine1: _.get(state, 'serverData.billingAddress.addressLine1'),
    addressLine2: _.get(state, 'serverData.billingAddress.addressLine2'),
    city: _.get(state, 'serverData.billingAddress.city'),
    state: _.get(state, 'serverData.billingAddress.state'),
    postalCode: _.get(state, 'serverData.billingAddress.postalCode')
});

export default connect(mapStateToProps)(injectIntl(AddressDisplay));
